import axios from 'axios';
import { createPayload } from '@/utils/createPayload';
import { reportSilentError } from '@/utils/storeErrorReporting';

const API_DOMAIN = import.meta.env.VITE_API_URL;

export const fetchEducatorFromId = async (educatorId) => {
    try {
        const { token } = await createPayload(null);

        if (!educatorId || typeof educatorId !== 'string') {
            throw new Error('Educator ID provided was invalid');
        }

        const response = await axios.get(`${API_DOMAIN}/educators/${educatorId}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });

        return response?.data;
    } catch (error) {
        reportSilentError(error);
        return undefined;
    }
};

/**
 * Creates an Educator record in Career Connect BE.
 */
export const createEducator = async (deEducatorMetadata) => {
    try {
        const { id: educatorId } = deEducatorMetadata;

        if (!educatorId || typeof educatorId !== 'string') {
            throw new Error('Educator ID provided was invalid');
        }

        const { token } = await createPayload(null);
        const response = await axios.post(`${API_DOMAIN}/educators/${educatorId}`, deEducatorMetadata, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });

        return response.data;
    } catch (error) {
        reportSilentError(error);
        return null;
    }
};
